import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { MonetaryAmountOutput } from '@sorare/core/src/hooks/useMonetaryAmount';
import { useFiatBalance } from '@sorare/core/src/hooks/wallets/useFiatBalance';
import {
  OrderedPaymentMethod,
  PaymentMethod,
} from '@sorare/core/src/lib/paymentMethod';

export const useWalletProjectedBalances = (
  monetaryAmount: MonetaryAmountOutput,
  paymentMethod?: OrderedPaymentMethod
) => {
  const { availableBalanceInCents, fiatCurrencyForMonetaryAmount } =
    useFiatBalance();
  const { currentUser } = useCurrentUserContext();
  if (paymentMethod === PaymentMethod.FIAT_WALLET) {
    const amountLeft =
      availableBalanceInCents - monetaryAmount[fiatCurrencyForMonetaryAmount];
    return {
      projectedFiatBalance: amountLeft < 0 ? 0 : amountLeft,
      projectedEthBalance: currentUser?.availableBalance,
    };
  }
  if (paymentMethod === PaymentMethod.ETH_WALLET) {
    const amountLeft =
      (currentUser?.availableBalance || 0n) - monetaryAmount.wei;
    return {
      projectedFiatBalance: availableBalanceInCents,
      projectedEthBalance: amountLeft < 0n ? 0n : amountLeft,
    };
  }
  return {
    projectedFiatBalance: availableBalanceInCents,
    projectedEthBalance: currentUser?.availableBalance,
  };
};
